import { SQL_JS_CONFIG } from 'common_lib/db/sqlite'
import initSqlJs, { Database, SqlValue } from 'sql.js'

export interface SearchResult extends Record<string, SqlValue> {
	item_type: string
	item_id: number
	item_subtype: string
	title: string
	tags: string
}

const placeBlobInCache = async (blob: Blob, checksum: string) => {
	const cache = await caches.open('searchIndexCache')
	await cache.put(checksum, new Response(blob))
}

const getBlobFromCache = async (checksum: string) => {
	const cache = await caches.open('searchIndexCache')

	try {
		const response = await cache.match(checksum)
		if (!response) throw new Error('Cache miss')
		return response.blob()
	} catch (e) {
		return null
	}
}

/**
 * Load search database
 * @param projectId
 * @param language
 * @returns
 */
export const getSearchDatabase = async (projectId: number, language: string, checksum: string) => {
	const SQL = await initSqlJs(SQL_JS_CONFIG)

	// Get database from cache
	let db: Blob = await getBlobFromCache(checksum)
	if (db === null) {
		const response = await fetch(
			`https://${ENV.BUNNY_DIRECT_DOMAIN}/search_indexes/project/${projectId}/search_index_${language}.db`,
		)
		db = await response.blob()
		await placeBlobInCache(db, checksum)
	}

	const buffer = await db.arrayBuffer()
	const uInt8Array = new Uint8Array(buffer)
	return new SQL.Database(uInt8Array)
}

/**
 * Search database
 * @param db The database
 * @param searchTerm The search term
 * @returns
 */
export const querySearchDatabase = (db: Database, searchTerm: string) => {
	// Filter search term
	searchTerm = searchTerm.replace(/[^\p{L}\p{N}]+/gu, '')
	if (!searchTerm) return []

	// Run query
	const metaStmt = db.prepare('SELECT * FROM search WHERE search MATCH :searchTerm;')
	const result = metaStmt.getAsObject({ ':searchTerm': searchTerm })

	// No results
	if (!result.item_id) return []

	// Results
	const rows = [result]
	while (metaStmt.step()) {
		rows.push(metaStmt.getAsObject())
	}

	return rows as SearchResult[]
}
